import gql from 'graphql-tag';
import { useQuery } from '@apollo/react-hooks';

import { makeGqlMock } from '@zapier/design-system-revenue/src/mocks';

export const currentUserQuery = gql`
  query currentUserQuery {
    currentUserV2 {
      id
    }
  }
`;

type Props = {
  skip?: boolean;
};

export const useCurrentUser = ({ skip }: Props = {}) => {
  const { data, error, loading } = useQuery(currentUserQuery, {
    skip,
  });

  return {
    currentUser: data?.currentUserV2,
    error: error ? 'Error loading current user information.' : undefined,
    isLoading: loading,
  };
};

export const useCurrentUserMock = makeGqlMock(
  {
    query: currentUserQuery,
  },
  {
    currentUserV2: {
      __typename: 'UserV2',
      id: '1',
    },
  }
);
